import { apiUrlOriginacao } from "@settings";
import { getMutationFn, getQueryFn } from "./base";

const BASE_URL = apiUrlOriginacao;
export const queryFnHappy = getQueryFn(BASE_URL);

export const getMutationFnHappy = <
  TData = unknown,
  TVariables extends Record<string, unknown> = Record<string, unknown>,
>(
  action?: Parameters<typeof getMutationFn>[1],
  method?: Parameters<typeof getMutationFn>[2],
  options: Parameters<typeof getMutationFn>[3] = {
    headers: {},
  },
) => {
  const mutationFn = getMutationFn<TData, TVariables>(
    BASE_URL,
    action,
    method,
    {
      ...options,
      headers: {
        ...options.headers,
      },
    },
  );

  return (variables: TVariables) => {
    const src = new URLSearchParams(window.location.search).get("src");
    const enrichedVariables = {
      ...variables,
      origin: window.location.origin,
      ...(src ? { src } : {}),
    } as TVariables;

    return mutationFn(enrichedVariables);
  };
};
